import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-login-back',
  templateUrl: './login-back.component.html'
})
export class LoginBackComponent {
  public postId;
  public errorMessage;

  constructor(private http: HttpClient) { }
}

interface LoginBack {
  id: number;
  email: string;
}
